import React, { memo, useState } from 'react';
import { usePermissions } from 'react-admin';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import roles from '../../constants/roles';
import ListVideos from './ListVideos';
import ListImages from './ListImages';

const VIDEOS = 'videos';
const IMAGES = 'images';

const MediaManager = () => {
  const [tab, setTab] = useState(VIDEOS);
  const { permissions } = usePermissions();

  // GET /api/file is restricted to Admin and SuperAdmin, so only offer the tab to them.
  const canManageImages = permissions === roles.superAdmin || permissions === roles.admin;
  const activeTab = tab === IMAGES && !canManageImages ? VIDEOS : tab;

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={activeTab} onChange={(event, value) => setTab(value)}>
          <Tab label="Videos" value={VIDEOS} />
          {canManageImages && <Tab label="Images" value={IMAGES} />}
        </Tabs>
      </Box>
      {activeTab === IMAGES ? <ListImages /> : <ListVideos />}
    </>
  );
};

export default memo(MediaManager);
